import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { StickySidebar } from 'sticky-sidebar'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)


// ================
// Use Element UI
// ----------------
window._ = require('lodash');
// import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/scss/main.scss'


// ================
// Lodash
// ----------------
import VueLodash from 'vue-lodash'
Vue.use(VueLodash)

// ================
// Use Vue Router
// ----------------
import router from './router'


// ================
// Vue-stash aka simple vuex alternative
// ----------------
import VueStash from 'vue-stash'
import store from './store'
Vue.use(VueStash)

Vue.config.productionTip = false
Vue.component('form-builder', require('./App.vue').default);
Vue.component('form-field-properties-for-crud', require('./components/bs/properties/Properties.vue').default);
Vue.component('form-renderer', require('./views/Render.vue').default);
Vue.component('form-renderer-for-review', require('./views/RenderForReview.vue').default);

var store0 = JSON.parse(JSON.stringify(store))
var store1 = JSON.parse(JSON.stringify(store))

$('.form-builder-container').map( function(index, element) {
  var data = { store: JSON.parse(JSON.stringify(store)) }

  new Vue({
    el: element,
    router,
    data,
    // render: h => h(App)
  })
});

